import ResizeObserver from 'resize-observer-polyfill';
import { TAB_TYPE } from './constant';
const { useDark } = require('@fegobull/webapi').use;
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');
export default {
    setup() {
        const { isAuto: isSkinAuto, isDark: isSkinDark } = useDark?.() || {};
        return {
            isSkinDark,
            isSkinAuto,
        };
    },
    data() {
        return {
            TAB_TYPE,
            headerObserver: null,
            current: 0,
            activeBarWidth: 0,
            activeBarLeft: 0,
        };
    },

    computed: {
        activeChild() {
            return (
                this.tpl.children.find((i) => {
                    return i.id === this.current;
                }) || this.tpl.children[0]
            );
        },
        headerStyle() {
            const { px2Rem } = this;
            return {
                lineHeight: px2Rem(this.tpl.props.headerHeight),
                height: px2Rem(this.tpl.props.headerHeight),
                justifyContent: this.tpl.props.headerJustifyContent
            };
        },
        headerScrollStyle() {
            return {
                ...this.headerStyle,
                justifyContent: 'flex-start'
            };
        },
        headerItemStyle() {
            const { px2Rem } = this;
            return {
                marginLeft: `${px2Rem(this.tpl.props.headerMargin)}`,
                marginRight: `${px2Rem(this.tpl.props.headerMargin)}`,
                fontSize: px2Rem(this.tpl.props.headerFontSize),
                fontFamily: this.tpl.props.headerFontFamily,
                color: this.tpl.props.headerFontColor
            };
        },
        headerItemActiveStyle() {
            const { px2Rem } = this;
            let style = {
                ...this.headerItemStyle,
                color: this.tpl.props.headerActiveColor,
                maxHeight: `${px2Rem(this.tpl.props.headerHeight)}`,
                fontWeight: 500
            };
            if (this.tpl.props.tabType === TAB_TYPE.CIRCLE) {
                style = Object.assign({}, style, {
                    backgroundColor: this.tpl.props.headerBarColor
                });
            }
            return style;
        },
        headerActiveBarStyle() {
            return {
                backgroundColor: this.tpl.props.headerBarColor,
                width: this.activeBarWidth + 'px',
                transform: `translateX(${this.activeBarLeft}px)`
            };
        },
        shouldShowBar() {
            return this.tpl.props.tabType === TAB_TYPE.LINE;
        }
    },

    methods: {
        px2Rem(px) {
            return rem.str(px);
        },

        /**
         * 重置 header bar 的样式
         */
        resetHeaderBar() {
            const element = this.$el.querySelector('.basic-tab-part.active');
            if (element) {
                const { left, width } = element.getBoundingClientRect();
                const { left: parentLeft } = element.parentElement.getBoundingClientRect();
                this.activeBarWidth = width;
                this.activeBarLeft = left - parentLeft;
            }
        },

        /**
         * 监听当前激活标题，同步设置 headerBar
         */
        observeHeader() {
            const element = this.$el.querySelector('.basic-tab-part.active');
            this.headerObserver = new ResizeObserver((entries) => {
                this.resetHeaderBar();
            });

            if (element) {
                this.resetHeaderBar();
                this.headerObserver.observe(element);
            }
        }
    },

    beforeDestroy() {
        // 确保在组件销毁时停止观察
        this.headerObserver?.disconnect();
    }
};
